<div class="pharmacyPage">
  <div class="pharmacy_header ie_fixed_add_pharmacy_header">
    <div class="container header_container">
      <h2>Pharmacies Available</h2>
      <div class="right_btn_sec">
        <div class="map_btn">
          <i></i>
          Locate on Map
          <input type="checkbox" id="locate" (click)="Showmapview()" />
          <label for="locate">
            <i></i>
          </label>
        </div>
        <div class="filterbtn_mobile" (click)="filteron_mobile()">
          <i></i>
          Filters
        </div>
        <div class="sortby" (click)="hideSortby(); $event.stopPropagation()">
          Sort By
          <i></i>
          <!-- Sort by list -->
        </div>
        <div class="sortby_ddl" [hidden]="!sortbyddl">
          <ul *ngIf="IsDistancesort">
            <li (click)="SortPharmacyList('Distance')">
              Distance
            </li>
            <li (click)="SortPharmacyList('Price')"  class="active">Price</li>
          </ul>
          <ul *ngIf="IsPricesort">
            <li (click)="SortPharmacyList('Distance')">Distance</li>
            <li (click)="SortPharmacyList('Price')" class="active">Price</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <!-- search start -->
  <div class="search-fields" id="searchBar">
    <app-search></app-search>
   </div>
 <!-- search end -->
  <div class="container" id="pharmacy_container">
    <div class="pharmacy_box">
      <div class="select_filterList_parent ie_fixed_add_select_filterList_parent">
        <i (click)="hide_filter_mobile_on()"></i>
        <div class="filter_box" [ngClass]="{'singleDoseForm': DrugNameTypeSingle}">
            <!-- <div class="filter_box"> -->
          <label>Type</label>
          <div class="type_box" (click)="hideothermenu()">
            {{ _DrugName }}
          </div>
          <div class="type_list">
            <ul>
              <li *ngFor="let item of DrugNameTypeList" [ngClass]="{ active: item == Swap_Drug_With_MultiSource_New }"
                  (click)="SwapDrugname(item)">
                  {{ item }}
                </li>
              <!-- <li class="active">Tablet</li> -->
            </ul>
          </div>
        </div>
        <div class="filter_box" [ngClass]="{'singleDoseForm': DrugFormSingle}">
          <label>Form</label>
          <div class="type_box" (click)="hideothermenu()">
            {{ _Type }}
          </div>
          <div class="type_list">
            <ul>
              <li *ngFor="let item of DrugFormTypeList" [ngClass]="{ active: item.text == _Type }"
                  (click)="SwapDrugForm(item.text)">
                  {{ item.text }}
                </li>
              <!-- <li class="active">Tablet</li> -->
            </ul>
          </div>
        </div>
        <div class="filter_box" [ngClass]="{'singleDoseForm': DrugDoseSingle}">
          <label>Dosage</label>
          <div class="type_box" (click)="hideothermenu()">
            {{ _Dose }}
          </div>
          <div class="type_list">
            <ul>
              <li *ngFor="let item of DrugDoseTypeList; let i = index" [ngClass]="{ active: item == _Dose }"
                  (click)="SwapDrugDose(item, i)">
                  {{ item }}
                </li>
              <!-- <li class="active">Tablet</li> -->
            </ul>
          </div>
        </div>
        <div class="filter_box">
          <label>quantity</label>
          <div class="type_box" (click)="hideothermenu()">{{ _Quant }}</div>
          <div class="type_list">
            <ul>
              <li *ngFor="let item of DrugQuantityTypeList" [ngClass]="{ active: item == _Quant }"
                  (click)="SwapDrugQuantity(item.Quantity, item.NDCCode, item.DisplayQuantity)">
                  {{ item.DisplayQuantity }}
                </li>
              <!-- <li  (click)="OpenQuantity_Box()">Enter a Quanity</li> -->
              <!-- <li>Powder</li>
              <li class="active">Tablet</li>
              <li>Suspension</li> -->
            </ul>
          </div>
        </div>
        <div class="filter_box">
          <label>Pharmacies Near</label>
          <div class="type_box Noddl" (click)="hideothermenu()">
            <input
              type="text"
              placeholder="Type zipcode"
              [(ngModel)]="_ZipCode"
              value="{{ _CurrLocation }}"
              (click)="ClearErrorMessage()"
              (keypress)="ZipCodeValidate($event)"
              maxlength="5" 
            />
          </div>
        </div>
        <span style="color:red">{{ ZipCodeMessage }}</span>
        <!-- <div class="update_btn" [class.loader]="pharmacy_list.length == 0" (click)="UpdatePharmacyList()">Update Search</div> -->
        <div class="update_btn loader" (click)="UpdatePharmacyList()">Update Search</div>
        <div *ngIf="pharmacyLoader" class="loader-popup">
          <div class="loader"></div>
        </div>
      </div>
      <div class="pharmacy_list ie_fixed_add_pharmacy_list" *ngIf="List_Pharmacy_Available">
        <div class="card" *ngFor="let item of pharmacy_list" (click)="showDiscountcard(item)">
          <div class="name_Sec">
            <p>{{ item.PharmacyName }}</p>
            <!-- <span>${{ item.Price }}</span> -->
            <span>${{item.Price | number: "1.2-2" }}</span>
          </div>
          <div class="distance">{{ item.Distance }} - Discount Card</div>
        </div>
        
      </div>
      <!-- <----------------No Pharmacy List Start------------------>
        <div class="pharmacy_list no_pharmacy ie_fixed_add_no_pharmacy" *ngIf="!List_Pharmacy_Available">
          <img src="../../assets/images/no-result@1x.svg" alt="" />
          <span class="notxt">Search for a Medication</span>
          <span>Use the search bar above to find your medication discounts</span>
        </div>
        <!-- <----------------No Pharmacy List End------------------>
         
      <div class="maps_box ie_fixed_add_maps_box" *ngIf="mapview && getBrowser == null">
        <agm-map [latitude]="lat" [zoom]="zoom" [longitude]="lng">
  
            <agm-marker
              [latitude]="lat"
              [longitude]="lng"
              iconUrl="../assets/images/User_Current.png"
              [label]="Discount_Card"
              [title]="AppName"></agm-marker>
          <agm-marker
            *ngFor="let marker of MarkersList"
            [latitude]="marker.lat"
            [longitude]="marker.lng"
              (markerClick)="SelectMapMarker(marker.Id)"
            iconUrl="../assets/images/maptooltip.png"
            [label]="{
              color: '#ffffff',
              fontWeight: '500',
              fontSize: '16px',
              fontfamily: 'FiraSans',
              text: '$' + convertstringtoint(marker.Price)
            }"
              [title]="marker.PAddress"
          >
          </agm-marker>
        </agm-map>
      </div>

      <div *ngIf="mapview && getBrowser == ''">
      <div class="maps_box ie_fixed_add_maps_box">
        <agm-map [latitude]="lat" [zoom]="zoom" [longitude]="lng">
          <agm-marker
              [latitude]="lat"
              [longitude]="lng"
              iconUrl="../assets/images/User_Current.png"
              [label]="Discount_Card"
              [title]="AppName"></agm-marker>
            <agm-marker
            *ngFor="let marker of MarkersList"
            [latitude]="marker.lat"
            [longitude]="marker.lng"
              (markerClick)="SelectMapMarker(marker.Id)"
            iconUrl="../assets/images/maptooltip.png"
            [label]="{
              color: '#ffffff',
              fontWeight: '500',
              fontSize: '16px',
              fontfamily: 'FiraSans',
              text: '$' + convertstringtoint(marker.Price)
            }"
              [title]="marker.PAddress"
          >
          </agm-marker>
        </agm-map>
      </div>
      </div>

    </div>
  </div>
  <!-- Discount Card -->
  <div class="discount_card" *ngIf="showcard" id="print-section">
    <div class="close_search_pharmacy_popup" (click)="CloseDrugDetails()"></div>
    <div class="discount_card_parent">
      <div class="header">
        <img src="../../assets/images/logo.png" alt="" />
        <div class="button_sec">
          <!-- <div class="sendsms">Send SMS</div> -->
          <div
            class="save"
            (click)="SaveCard()"
            [class.saved]="IsSave == 'Remove'"
          >
            {{ IsSave }}
          </div>
          <div class="print" (click)="PrintMe()">Print</div>
          <!-- <button  printTitle="MyTitle"   [useExistingCss]="true"   styleSheetFile="src\styles.scss" printSectionId="print-section" ngxPrint>print</button> -->
        </div>
      </div>
      <!-- <div class="logoarea" *ngIf="Card_Pharmacy_Logo">
        <div class="singlecare">
          <img src="../../assets/images/singlecare.svg" alt="">
        </div>
        <div class="walmart_img" *ngIf="RXS_Walmart">
          <span>Available at</span>
          <img src="http://rxhacker.23byt.es/MailSnap/wallmart.svg" alt="">
        </div>
        <div class="cvs_img" *ngIf="RXS_CVS">
            <span>For exclusive use at</span>
            <img src="http://rxhacker.23byt.es/MailSnap/cvs.svg" alt="">
          </div>
      </div> -->
      <div class="pharmacybox">
        <div class="name_quantity">
          <p>{{ Card_DrugName }}</p>
          <span
            >{{ Card_Quantity }} {{ Card_DrugForm }} | {{ Card_Dosage }}</span
          >
        </div>
        <div class="price">${{ PharmacyPrice }}</div>
      </div>
      <div class="pharmacyDetail">
        <p class="notInsurance">This card is free. <strong>This is not insurance.</strong></p>
        <div class="name">
          {{ SelectPharmacy }}
        </div>
        <div class="address">{{ PAddress2 }}</div>
        <div class="number">{{ PharmacyPhone }}</div>
        <div class="method_salt">
          <div class="method">
            <div>bin</div>
            <div>{{ RXBin }}</div>
          </div>
          <div class="method">
            <div>PCN</div>
            <div>{{ RXCPN }}</div>
          </div>
          <div class="method">
            <div>Member ID</div>
            <div>{{ MemberId }}</div>
          </div>
          <div class="method">
            <div>Group</div>
            <div>{{ GroupNumber }}</div>
          </div>
        </div>
          <div class="email_field" style="position: relative">
          <input
            type="email"
            id="email"
            name="ShareEmail"
            placeholder=" "
            [(ngModel)]="UserInputEmail"
            (click)="ClearMessage($event)"
              (blur)="ClearMessage($event)"
            (keypress)="clearClassMsg()"
            autocomplete="off"
          />
          <label for="email">Enter your e-mail</label>
          <div class="sendbtn" (click)="ShareDiscountCard()">Send</div>
          <div class="loadProcess"></div>
        </div>
        <span style="color:red">{{ SendDiscountMessage }}</span>
        <div class="helpline_btn">
          <div class="helpline" (click)="PharmacyHelpLine()">
            <a href="tel:{{ PharmacistHelpline }}">{{ PharmacistHelpline }}</a>
          </div>
          <div class="direction" (click)="RedirectGoogleDirection()">
            Get Directions
            <img src="../../assets/images/direction.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- iconUrl="https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png"  -->
<!-- [label]="marker.Price" -->

<!-- Enter Quantity Manual Box -->
<div class="change_password" *ngIf="ManualQuantity_box">
  <!-- <div class="close_search_pharmacy_popup" (click)="removeforgot($event)"></div> -->
  <div class="changepassword_main forgot_pass">
    <h2>Enter a quantity</h2>
    <div class="input_box">
      <div>
        <input type="number" id="Quantity_Manual" name="Quantity_Manual" placeholder=" " [(ngModel)]="Quantity_Manual" (keypress)="DrugQuantityValidate($event)"/>
        <label for="Quantity_Manual">Quantity</label>
      </div>
      <span style="color:red" id="Quant_Error">{{ Quantity_error }}</span>
      <div class="reset_button" (click)="SubmitQuantity()">Submit</div>
    </div>
  </div>
</div>